module.exports = __webpack_public_path__ + "static/media/rocket_building.e3c17efd.gif";